<template>
  <div class="menu">
    <div class="menu-container">
      <label v-if="false" class="mobile-search-wrap search-wrap" for="searchm">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 22 22"
          width="22px"
          height="22px"
        >
          <g fill="none" fill-rule="evenodd">
            <path
              fill="#fff"
              d="M7.69921875 3.07421875C9.29037254 1.48306496 11.2031138.6875 13.4375.6875s4.1471275.79556496 5.7382812 2.38671875C20.766935 4.66537254 21.5625 6.57811383 21.5625 8.8125c0 2.2343862-.795565 4.1471275-2.3867188 5.7382812C17.5846275 16.141935 15.6718862 16.9375 13.4375 16.9375c-1.9296971 0-3.63931547-.6093689-5.12890625-1.828125l-6.44921875 6.5-1.21875-1.21875 6.5-6.4492187C5.92186891 12.4518155 5.3125 10.7421971 5.3125 8.8125c0-2.23438617.79556496-4.14712746 2.38671875-5.73828125zM18.0078125 4.2421875C16.7552021 2.95572273 15.2317798 2.3125 13.4375 2.3125s-3.3261655.63475928-4.59570312 1.90429688C7.57225928 5.48633447 6.9375 7.0182202 6.9375 8.8125c0 1.7942798.63475928 3.3261655 1.90429688 4.5957031C10.1113345 14.6777407 11.6432202 15.3125 13.4375 15.3125c1.7942798 0 3.3261655-.6347593 4.5957031-1.9042969C19.3027407 12.1386655 19.9375 10.6067798 19.9375 8.8125c0-1.7942798-.6432227-3.31770207-1.9296875-4.5703125z"
            />
          </g>
        </svg>
        <search-field />
      </label>
      <nav class="menu-nav">
        <!--<a href="index.php" class="active">Forsíða</a>-->
        <!-- <a href="/">Leita</a>-->
        <!-- <router-link :class="[{active:$route.path == '/'}, {show: countMenuItems}]" to="/">Bílasölur </router-link> -->
        <a
          v-for="(page, index) in pageLinks"
          :key="index"
          :class="{ active: page.components.indexOf($route.name) >= 0 }"
          @click.prevent="resetStoreData(page); routerPush(page)"
        >
          {{ page.name }}
        </a>

        <!--                <router-link :class="[{ active: $route.path == '/bilaumbod' }]" to="/bilaumbod"-->
        <!--                             @click.native="resetScrollTop()">-->
        <!--                    Bílaumboð-->
        <!--                </router-link>-->
        <!-- <router-link :class="[{active:$route.path == '/tilbodsbilar'}]" to="/tilbodsbilar?eyJ2ZXJkdGlsYm9kIjp0cnVlfQ">Tilboðsbílar</router-link> -->
        <!--                <router-link to="/notifications">Vistuð leit</router-link>-->
        <!--                <router-link to="/favorites">Eftirlæti</router-link>-->
        <!--                <router-link to="/allt-um-bila">Allt um bíla</router-link>-->
        <!--                <router-link to="/about-project">Um Okkur</router-link>-->
      </nav>
      <div class="user-login">
        <div v-if="!user">
          <router-link to="/register" class="register-icon">
            <img src="/img/profile/user-login.svg" />
          </router-link>
          <a @click="$store.state.popup = 'sign-in'" class="user-login-link"
            >Innskráning</a
          >
          <a @click="$store.state.popup = 'reg'" class="user-login-link"
            >Ný skráning</a
          >
          <!-- <router-link to="/register" class="user-login-link">  Ný skráning  </router-link> -->
        </div>
        <div
          style="
            display: flex;
            width: 300px;
            position: relative;
            margin-right: 10px;
          "
          v-if="user"
        >
          <div>
            <router-link style="border: none" to="/profiles">
              <img class="circl" :src="profile.pic" />
            </router-link>
          </div>
          <div style="margin-left: 10px">
            <div
              style="
                font-size: 18px;
                color: white;
                font-weight: bold;
                margin-bottom: 10px;
              "
            >
              {{ profile.full_name }}
            </div>
            <router-link to="/profiles" style="margin-left: 0px" href="#"
              >Stillingar</router-link
            >
            <logout-btn>
              <img
                style="top: 3px; position: relative; margin-left: 10px"
                src="/img/logout.svg"
              />
              Útskrá
            </logout-btn>
          </div>
        </div>
      </div>
      <PromoBlue />
      {{ this.showMenu }}
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import SearchField from "./SearchField.vue";
import PromoBlue from "./PromoBlue.vue";
import LogoutBtn from "./login/LogoutBtn.vue";
import mixinMobileLinks from '@/mixins/mobileLinks'

export default {
    mixins: [mixinMobileLinks],

  components: {
    "search-field": SearchField,
    PromoBlue,
    LogoutBtn,
  },

  props: ["user", "profile", "showElement"],

  data: () => ({
    countMenuItems: 0,
  }),

  methods: {
    ...mapMutations({
      setData: "SET_DATA",
      resetOldCars: "moduleOldCars/RESET_CARS",
    }),
    showItemsMenu() {
      let lengthElements = document.querySelectorAll(".menu-nav a").length;
      let elMenuNav = document.querySelector(".menu-nav");
      let timeout = 0;

      setTimeout(function () {
        for (let i = 0; i < lengthElements; i++) {
          setTimeout(
            (function (N) {
              return function () {
                /* console.log(`${N}: ${elMenuNav.children[N]}`); */
                elMenuNav.children[N].classList.add("show");
              };
            })(i),
            timeout
          );
          timeout += 100;
        }
      }, 200);
    },
    hideItemsMenu() {
      let lengthElements = document.querySelectorAll(".menu-nav a").length;
      let elMenuNav = document.querySelector(".menu-nav");

      for (let i = 0; i < lengthElements; i++) {
        elMenuNav.children[i].classList.remove("show");
      }
    },
    resetScrollTop() {
      this.$store.state.scrollPositionPageDealers = 0;
    }
  },
  computed: {
    pageLinks() {
      return this.$store.state.pageLinks.filter(function (e) {
        return e.target && e.target.indexOf("popup") >= 0;
      });
    },
    showMenu() {
      this.$store.state.showMobilePopUpMenu = this.showElement;
      if (this.showElement) {
        this.showItemsMenu();
      } else {
        this.hideItemsMenu();
      }
      return;
    },
  },
};
</script>
